import { render, staticRenderFns } from "./Step1Category.vue?vue&type=template&id=61f56a3d&scoped=true"
import script from "./Step1Category.vue?vue&type=script&lang=js"
export * from "./Step1Category.vue?vue&type=script&lang=js"
import style0 from "./Step1Category.vue?vue&type=style&index=0&id=61f56a3d&prod&lang=css"
import style1 from "./Step1Category.vue?vue&type=style&index=1&id=61f56a3d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f56a3d",
  null
  
)

export default component.exports